"use client";

import Link from "next/link";

import type { HeaderMilestoneAdStudioVariant } from "./types";

import MilestonesButtonFramerComponent from "@/framer/header-navbar/milestones-button";

export interface HeaderMilestonesAdstudioButtonProps {
	variant?: HeaderMilestoneAdStudioVariant;
	milestonesHref?: string;
	adStudioHref?: string;
	ariaLabel?: string;
}

function resolveHref(
	variant: HeaderMilestoneAdStudioVariant,
	milestonesHref: string,
	adStudioHref?: string,
) {
	const isAdStudioVariant = variant === "Variant 3" || variant === "Variant 4";
	if (!isAdStudioVariant) return milestonesHref;
	return adStudioHref ?? milestonesHref;
}

export function HeaderMilestonesAdstudioButton({
	variant = "Variant 1",
	milestonesHref = "/milestones",
	adStudioHref,
	ariaLabel = "Milestones",
}: HeaderMilestonesAdstudioButtonProps) {
	const href = resolveHref(variant, milestonesHref, adStudioHref);

	return (
		<Link href={href} className="contents" aria-label={ariaLabel}>
			<MilestonesButtonFramerComponent.Responsive variants={{ base: variant }} />
		</Link>
	);
}
